export default defineNuxtPlugin((nuxtApp) => {
  const { syncWithServer } = useAuthStore();

  // Sync auth state on route changes
  nuxtApp.hook("page:finish", () => {
    syncWithServer();
  });
});
